import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./skeleton.css?inline";

@customElement("eko-skeleton")
class Skeleton extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true, type: Boolean }) animated = false;

  render() {
    return html`<div class="eko-skeleton"></div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-skeleton": Skeleton;
  }
}

export default Skeleton;
